import React from 'react'

const Navbar = () => {
  return (
    <>
    <h2 className='text-center navhead' > Recipe Application </h2>
    </>
  )
}

export default Navbar